





/* jshint nomen:false */
 
 
 
 
 
 
/**
 * Class that represents a unit of measurement.
 *
 * @class Unit
 * @module Models
 */
define(['./unitTypes'], function(unitTypes) {
    'use strict';
    function Unit(unit) {
        if (!(unit in unitTypes)) {
            console.warn('Incorrect unit passed: ' + unit + '. Defaulted to metric');
            unit = unitTypes.metric;
        }
        this.unit = unit;
    }

    /**
     * Returns the label of the unit.
     * @method getLabel
     * @return {String}
     */
    Unit.prototype.getLabel = function() {
        return this.unit;
    };

    return Unit;
});



// WEBPACK FOOTER //
// ./config/unit/unit.js